import styled from 'styled-components';

import { Text } from '../../../cdl/Text/Text';
import { theme } from '../../ui/theme';

export const SidebarSectionHeading = styled(Text).attrs({
    color: 'foreground.subtle',
    fontWeight: 600,
    variant: 'extraSmall',
})`
    margin-bottom: ${theme.space[8]};
    padding: 0 ${theme.space[8]};
`;
